const actionTypes = {
  SET_SIDEBAR_TOGGLE: 'SET_SIDEBAR_TOGGLE',
}

export default actionTypes
